module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm06_ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "indent9"
  }, [_vm._v("Many people have helped in various ways to make this book a reality, though only a few can be singled out for mention. Professor Leslie A. White, of the University of Michigan, teacher and friend, gave me the courage to face this task, as well as instilling whatever insight I possess into the nature of culture. The staff of the Texas Memorial Museum has been co-operative and long-suffering. Dr. E. H. Sellards, former director of the Museum, encouraged me in this project. Mrs. Willena Casey Adams, former Museum secretary, has typed the manuscript several times, provided editorial assistance, and always been optimistic about the worth of this endeavor. Hal M. Story, Museum artist, has spent many of his leisure hours working on illustrations. Their completion spurred me on to finish my writing task. Dr. T. N. Campbell, chairman of the Department of Anthropology, University of Texas, has generously given of his time and vast knowledge of Texas Indians. Finally, my wife, Gleny, has been patient and a source of constant encouragement. Without her this could never have been written.")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("W. W. N., J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Texas Memorial Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Austin, Texas")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a414c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_ack.vue
// module id = 75
// module chunks = 0